
import { Card, CardContent } from "@/components/ui/card";

interface StatCardProps {
  title: string;
  count: number;
  onClick: () => void;
  countSuffix?: string;
}

export const StatCard = ({ title, count, onClick, countSuffix }: StatCardProps) => {
  return (
    <Card 
      className="bg-flux-black/50 border border-flux-cyan/20 cursor-pointer hover:bg-flux-black/70 transition-colors"
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex justify-between items-center">
          <h3 className="text-flux-cyan">{title}</h3>
          <span className={`${countSuffix ? 'text-gray-400' : 'text-2xl font-bold text-white'}`}>
            {count}{countSuffix}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
